module.exports = __webpack_public_path__ + "static/img/kaishihuiyi2.0373cf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/kaishihuiyi2.png
// module id = afdW
// module chunks = 24